import React from 'react';

import { Navigate, Outlet } from 'react-router-dom'
import { getAuthToken } from '../utils/helper';

const useAuth = () => {
    const user = getAuthToken()
    if (user) {
        return true
    } else {
        return false
    }
}

const PublicRoutes = (props) => {

    const auth = useAuth()
    return auth ? <Navigate to="/" /> : <Outlet />
}


export default PublicRoutes;;